const handleResponse = (response) => {
  if (response.status === 401) {
    logout();
    window.location.reload(true);
  }
}

const handleErrorResponse = (error) => {
  if (error) {
    console.log(error);
  }
}

const logout = () => {
  localStorage.removeItem("token");
  window.location.replace("/login");
}

const isAuthenticated = () => {
  if (localStorage.getItem("token")) {
    return true;
  }
  return false;
}

export {
  handleResponse,
  handleErrorResponse,
  logout,
  isAuthenticated
}
